//Get Reducer Call--->
export const getSettingsRequest = (page: number, size: number, search: string) => ({
    type: 'GET_SETTINGS_REQUEST',
    payload: { page, size, search },
});

export const getSettingsSuccess = (data: any) => ({
    type: 'GET_SETTINGS_SUCCESS',
    payload: { data },
});

export const getSettingsFailure = (data: string) => ({
    type: 'GET_SETTINGS_FAILURE',
    payload: { data },
});

export const resetGetSettings = () => ({
    type: 'RESET_GET_SETTINGS',
});

//Create Reducer Call--->
export const createSettingsRequest = (data: any) => ({
    type: 'CREATE_SETTINGS_REQUEST',
    payload: data,
});

export const createSettingsSuccess = (data: any) => ({
    type: 'CREATE_SETTINGS_SUCCESS',
    payload: { data },
});

export const createSettingsFailure = (data: string) => ({
    type: 'CREATE_SETTINGS_FAILURE',
    payload: { data },
});

export const resetCreateSettings = () => ({
    type: 'RESET_CREATE_SETTINGS',
});

//Update Reducer Call--->
export const updateSettingsRequest = (data: any, id: string) => ({
    type: 'UPDATE_SETTINGS_REQUEST',
    payload: { data, id },
});

export const updateSettingsSuccess = (data: any) => ({
    type: 'UPDATE_SETTINGS_SUCCESS',
    payload: { data },
});

export const updateSettingsFailure = (data: string) => ({
    type: 'UPDATE_SETTINGS_FAILURE',
    payload: { data },
});

export const resetUpdateSettings = () => ({
    type: 'RESET_UPDATE_SETTINGS',
});


//Update Reducer Call--->
export const updateUserCredentialsRequest = (data: any, id: string) => ({
    type: 'UPDATE_USER_CREDENTIALS_REQUEST',
    payload: { data, id },
});

export const updateUserCredentialsSuccess = (data: any) => ({
    type: 'UPDATE_USER_CREDENTIALS_SUCCESS',
    payload: { data },
});

export const updateUserCredentialsFailure = (data: string) => ({
    type: 'UPDATE_USER_CREDENTIALS_FAILURE',
    payload: { data },
});

export const resetUserCredentialsSettings = () => ({
    type: 'RESET_UPDATE_USER_CREDENTIALS',
});
// //Delete Reducer Call--->
// export const deleteSettingsRequest = ( id: string) => ({
//   type: 'DELETE_SETTINGS_REQUEST',
//   payload: { id },
// });

// export const deleteSettingsSuccess = (data: any) => ({
//   type: 'DELETE_SETTINGS_SUCCESS',
//   payload: { data },
// });

// export const deleteSettingsFailure = (data: string) => ({
//   type: 'DELETE_SETTINGS_FAILURE',
//   payload: { data },
// });

// export const resetDeleteSettings = () => ({
//   type: 'RESET_DELETE_SETTINGS',
// });
